import React from 'react'
import GlobalHeroFilter from './GlobalHeroFilter'
import ButtonPropertyMobile from './ButtonPropertyMobile';

const HeroFilter = () => {
  return (
    <div style={{height:"100%",display:"flex",flexDirection:"column",justifyContent:"end"}}>
            <div id='comofunciona' className="home-text text-center" style={{background:"rgba(0, 0, 0, 0.2)",padding:"4% 4% 0 4%"}}>
                <h1 className='fz_title_hero_owner'> Alugue o seu imóvel com a YOLO e aproveite o que mais importa na sua vida</h1>                          
                <ButtonPropertyMobile/>
            </div>            
        </div>
  );
}

export default HeroFilter